






















































import Vue, { CreateElement, RenderContext } from 'vue';
import { defineComponent, provide, reactive, computed, onBeforeUpdate } from '@vue/composition-api';
import { WokDataGridConfiguration, isNumericDataType } from './abstractions';
import { isTrue, isFalse } from '../helpers';
import WokDataGridColumnsHeader from './WokDataGridColumnsHeader.vue';
import WokDataGridColumnsTotals from './WokDataGridColumnsTotals.vue';
import WokDataGridRowWrapper from './WokDataGridRowWrapper';

export default defineComponent({
    name: 'WokDataGridSection',

    components: { WokDataGridRowWrapper, WokDataGridColumnsHeader, WokDataGridColumnsTotals },

    props: {
        items: {
            type: Array,
            required: true
        },
        itemsKey: {
            type: [Function, String],
            default: 'id'
        },
        filter: {
            type: Function,
            default: undefined
        },
        enableSelection: {
            type: [String, Boolean],
            default: false
        },
        hideHeader: {
            type: [String, Boolean],
            default: false
        },
        hideTotals: {
            type: [String, Boolean],
            default: false
        },
        totalsPosition: {
            type: String,
            default: 'bottom',
            validator: (v: string) => /(top|bottom)/.test(v)
        },
        locale: {
            type: Object,
            default: undefined
        }
    },

    setup(props, context) {
        const cfg: WokDataGridConfiguration = reactive({
            columns: [],
            locale: computed(() => props.locale),
            enableSelection: computed(() => props.enableSelection),
            update: false
        })

        const hasHeader = computed(() => {
            return isFalse(props.hideHeader);
        })

        const hasTotals = computed(() => {
            return isFalse(props.hideTotals)
                && cfg.columns.some(x => (x.dataName && isNumericDataType(x.dataType)) || x.dataAggregate != null);
        })

        const sectionClasses = computed(() => {
            return {
                'wok--data-grid__table-section': true,
                'wok--body-short-01': true,
                'wok--data-grid__table-section--top': context.slots.top != null,
                'wok--data-grid__table-section--no-top': context.slots.top == null,
                [`wok--data-grid__table-section--totals-${props.totalsPosition}`]: props.totalsPosition
            };
        })

        const getItemKey = (item: any, index: number) => {
            let key = null;
            if (typeof props.itemsKey == 'string') {
                key = item[props.itemsKey];
            }
            else if (typeof props.itemsKey == 'function') {
                // FIXME: defineComponent typing is broken and sets type to string.
                key = (<any>props.itemsKey)(item, index);
            }
            return key != null ? key : index;
        }

        const filteredAndSortedItems = computed(() => {
            // Assign the 0-based index to items and optionally filters them.
            let items = props.items.map((x, i) => ({ item: x, index: i, key: getItemKey(x, i), row: 0 }));
            if (props.filter) {
                items = items.filter(props.filter);
            }
            // Assign the 1-based row to filtered items.
            for (let i = 0 ; i < items.length ; i++) {
                items[i].row = i + 1;
            }
            return items;
        })

        const onTableClick = (evt: Event) => {
            // Check for a click on a table cell.
            if (evt.target instanceof HTMLTableCellElement) {
                let row = parseInt(evt.target.dataset.row!);
                if (row != null && !isNaN(row)) {
                    context.emit('cell-click', { row: row, index: row - 1, name: evt.target.dataset.name });
                }
            }
        }

        provide('wokDataGridConfiguration', cfg)

        onBeforeUpdate(() => cfg.update = true)

        return {
            cfg,
            sectionClasses,
            filteredAndSortedItems,
            hasHeader,
            hasTotals,
            onTableClick
        }
    }
})
